<template>
  <div class="box">111111111111111111111111</div>
</template>

<script>
export default {
  name: 'test-0236',
  beforeRouteEnter(to, from, next) {
    console.log('=======', from)
    next()
  },
}
</script>

<style scoped>
</style>